let lazyLoading = [];

function lazyLoad() {
    const lazyImages = document.querySelectorAll('img[data-src]');
    for (let i = 0; i < lazyImages.length; i++) {
        if (imageInViewport(lazyImages[i].parentNode.parentNode)) {
            if (lazyImages[i].hasAttribute('data-src')) {
                lazyImages[i].src = lazyImages[i].dataset.src;
                lazyImages[i].srcset = lazyImages[i].dataset.srcset;
                lazyImages[i].sizes = lazyImages[i].dataset.sizes;
                delete lazyImages[i].dataset.src;
                delete lazyImages[i].dataset.srcset;
                delete lazyImages[i].dataset.sizes;
                lazyImages[i].dataset.loaded = true;
                lazyImages[i].style.visibility = 'visible';
                lazyImages[i].classList.add('img-loaded');
            }
        }
    }

    cleanLazy();
}

function cleanLazy() {
    lazyLoading = Array.prototype.filter.call(lazyLoading, function(l) {
        return l.dataset.src;
    });
}

function imageInViewport(el) {
    let rect = el.getBoundingClientRect();
    
    return (
        rect.bottom >= 0 &&
        rect.right >= 0 &&
        rect.top <= (window.innerHeight || document.documentElement.clientHeight) + 50 &&
        rect.left <= (window.innerWidth || document.documentElement.clientWidth)
    );    
}

let loadFunction = function(event) {
    lazyLoad();
};


export default loadFunction;